<template>
  <v-app>
    <section id="app" class="theme-dark-full">
      <loading ref="loading" />

      <demo-environment-notice />

      <transition name="page" mode="out-in">
        <component :is="layout" v-if="layout" />
      </transition>
    </section>
  </v-app>
</template>

<script>
import Loading from './Loading';
import DemoEnvironmentNotice from './DemoEnvironmentNotice';

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

export default {
  el: '#app',

  components: {
    Loading,
    DemoEnvironmentNotice,
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default',
  }),

  metaInfo() {
    window.config = { appName: 'Distribuidores' };
    const appName = 'Distribuidores';

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`,
    };
  },

  mounted() {
    this.$loading = this.$refs.loading;
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    },
  },
};
</script>
